import React from 'react';
import moment from 'moment';
import { prop } from 'ramda';

import Info from 'Components/Info';
import Slider from 'Components/Slider';
import DatePicker from 'Components/DatePicker';
import ProgressBar from 'Components/ProgressBar';

const EMPTY_CELL = <div>-</div>;

export default function SummaryCheckList({
  checklist,
  user,
  isInternalUser,
  chosenYear,
  documentTypeForListLink,
  onCheckListStatusChange,
  onCheckListDateChange,
  onCheckListAutomationChange,
  onCheckListApplicableChange,
}) {
  if (!checklist.length) {
    return null;
  }

  const redirectToDocuments = statusType => () => {
    if (documentTypeForListLink[statusType]) {
      user.goTo(
        user.getDocumentsLink({
          chosenYear,
          filter: { typeTitle: documentTypeForListLink[statusType] },
        })
      );
    }
  };

  const totalItemsAmount = checklist.filter(prop('isApplicable')).length;
  const checkedItemsAmount = checklist.reduce(
    (acc, { isChecked, isApplicable }) => isApplicable && isChecked ? acc + 1 : acc,
    0
  );

  return (
    <React.Fragment>
      <section className='scene_section  _padding_top_15 _padding_bottom_20'>
        <header>{`Checklist Progress ${checkedItemsAmount} of ${totalItemsAmount}`}</header>
        <ProgressBar maxValue={totalItemsAmount} value={checkedItemsAmount} mainWrapperClassName='_margin_top_20' />
      </section>

      <section className='scene_section  _padding_top_15 _padding_bottom_20'>
        <header>Certification Checklist</header>
        <div className='list__wrapper _margin_top_20'>
          <div className='list__row list__header list__header_small'>
            <div className='list__row-item list__header-item_small list__row-item_place-filler'>Document</div>
            <div className='list__row-item list__header-item_small _width_pc_20'>Date</div>
            {isInternalUser && (
              <div className='list__row-item list__header-item_small _width_pc_20 _text_align_center'>Automatic</div>
            )}
            <div className='list__row-item list__header-item_small _width_pc_20 _text_align_center'>
              Passed or Signed
            </div>
            {isInternalUser && (
              <div className='list__row-item list__header-item_small _width_pc_20 _text_align_center'>
                Not Applicable
              </div>
            )}
          </div>

          {checklist.map(
            ({ id, autoSet, date, hasAutoSet, name, statusType, isChecked, isApplicable, updated }, index) => (
              <div key={id} className='list__row list__row_small'>
                <div
                  className={`list__row-item list__row-item_small list__row-item_place-filler ${
                    documentTypeForListLink[statusType] ? '_cursor_pointer __hover-bold-text' : ''
                  }`}
                  onClick={redirectToDocuments(statusType)}
                >
                  {`${index + 1}. ${name}`}
                </div>

                <div className='list__row-item list__row-item_small list__row-item_component _width_pc_20 _jc_start'>
                  {!isApplicable ? (
                    EMPTY_CELL
                  ) : isChecked ? (
                    <React.Fragment>
                      {moment(date || updated)
                        .local()
                        .format('MM/DD/YYYY')}
                      {isInternalUser && (
                        <DatePicker
                          selectedDate={date || updated}
                          noInput
                          handleSelectDate={onCheckListDateChange(id)}
                        />
                      )}
                    </React.Fragment>
                  ) : (
                    <div className='_margin_left_30'>-</div>
                  )}
                </div>

                {isInternalUser && (
                  <div className='list__row-item list__row-item_small list__row-item_component _width_pc_20'>
                    {!isApplicable || !hasAutoSet ? (
                      EMPTY_CELL
                    ) : (
                      <Slider
                        state={!autoSet}
                        mainWrapperClassName={`${autoSet ? 'green' : ''}`}
                        sliderBodyClassName='slider-body_small'
                        toggleAction={() => onCheckListAutomationChange(id)}
                      />
                    )}
                  </div>
                )}

                <div className='list__row-item list__row-item_small list__row-item_component _width_pc_20'>
                  {!isApplicable ? (
                    EMPTY_CELL
                  ) : autoSet ? (
                    <Info
                      triggerElement={
                        <div
                          className={`${
                            isChecked
                              ? '__checkbox_checked __checkbox_checked_frozen'
                              : '__checkbox_red-exclamation-mark '
                          }`}
                        />
                      }
                      popperElement={<div className='info__tooltip-body'>Will be updated automatically</div>}
                    />
                  ) : (
                    <div
                      className={`${isChecked ? '__checkbox_checked' : '__checkbox_empty'} ${
                        user.isInternal() ? '_cursor_pointer' : ''
                      }`}
                      onClick={() => onCheckListStatusChange(id)}
                    />
                  )}
                </div>
                {isInternalUser && (
                  <div className='list__row-item list__row-item_small list__row-item_component _width_pc_20'>
                    {hasAutoSet ? (
                      EMPTY_CELL
                    ) : (
                      <div
                        className={`${isApplicable ? '__checkbox_empty' : '__checkbox_checked'} ${
                          user.isInternal() ? '_cursor_pointer' : ''
                        }`}
                        onClick={() => onCheckListApplicableChange({ id, prevValue: isApplicable })}
                      />
                    )}
                  </div>
                )}
              </div>
            )
          )}
        </div>
      </section>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/app/Scenes/SummaryScene/CheckList.jsx